export default {
  selectorWrapper: {
    marginTop: 8
  }
}
